import { ref, watch, computed } from '@vue/composition-api';
import { DOCUMENT, TABLE } from '@/constants/config';
import { pluck } from '@/helpers';

export default function useDirectorInterestsTable(status) {
    const refDocumentListTable = ref(null);

    const perPage = ref(TABLE.PER_PAGE);
    const totalFileOrFolders = ref(0);
    const currentPage = ref(1);
    const perPageOptions = TABLE.PER_PAGE_OPTIONS;
    const searchQuery = ref('');
    const sortBy = ref('id');
    const isSortDirDesc = ref(true);
    const isBusy = ref(false);
    const isLoading = ref(false);
    const tableColumns = ref([]);
    const dataStatus = ref('review-document');

    if(status === 'reviewDocuments') {
        dataStatus.value = 'review-document';
        tableColumns.value = [
            { key: 'selectAll', thClass:'py-0 select-input', tdClass:'py-0 select-input'},
            { key: 'fileName', label: 'DOCUMENT NAME', sortable: true, tdClass:'review-contents'},
            { key: 'status', label: 'STATUS', tdClass:'review-contents'},
            { key: 'sentOn', label: 'SENT ON', tdClass:'review-contents'},
            { key: 'reivew-actions', label: 'ACTION', thClass: 'text-right', tdClass:'text-right review-contents'},
        ];
    } else if(status === 'pendingSignatures') {
        dataStatus.value = 'pending-signature';
        tableColumns.value = [
            // { key: 'date', label: 'DATE', sortable: true, tdClass:'py-1 text-nowrap'},
            { key: 'fileName', label: 'DOCUMENT NAME', sortable: true, tdClass:'py-1'},
            { key: 'signDate', label: 'SIGNED DATE', tdClass:'py-1'},
            // { key: 'actions', label: 'ACTION', thClass: 'text-right text-dark', tdClass:'py-1' },
        ];
    } else if (status === 'pendingYourSignatures') {
        dataStatus.value = 'pending-your-signature';
        tableColumns.value = [
            { key: 'fileName', label: 'DOCUMENT NAME', sortable: true, tdClass:'py-1'},
            { key: 'status', label: 'STATUS', tdClass:'py-0'},
            { key: 'actions', label: 'ACTION', thClass: 'text-right text-dark', tdClass:'py-1' },
        ];
    } else if (status === 'pendingOtherSignatures') {
        dataStatus.value = 'pending-other-signature';
        tableColumns.value = [
            { key: 'fileName', label: 'DOCUMENT NAME', sortable: true, tdClass:'py-1'},
            { key: 'name', label: 'PENDING USERS', sortable: true, tdClass:'py-1'},
        ];
    }
    else {
        dataStatus.value = 'completed-signature';
        tableColumns.value = [
            { key: 'date', label: 'DATE', sortable: true, tdClass:'py-1'},
            { key: 'fileName', label: 'DOCUMENT NAME', sortable: true, tdClass:'py-1'},
            { key: 'signDate', label: 'SIGNED DATE', tdClass:'py-1'},
        ];
    }

    // options where the search query is applied
    // make sure to list as keys of how to access those values in table 
    const filterOn = ref([
        'fileName',
    ]);

    const dataMeta = computed(() => {
        const localItemsCount = refDocumentListTable.value ? refDocumentListTable.value.localItems.length : 0;
        totalFileOrFolders.value = localItemsCount;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalFileOrFolders.value,
        };
    });

    const refetchData = () => {
        refDocumentListTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
        refetchData();
        const queryLowered = searchQuery.value.toLowerCase().trim();
        
        //  if a query present then search
        if (queryLowered)
        {
            refDocumentListTable.value.localItems= refDocumentListTable.value.localItems.filter(item => filterOn.value.some(key => {
                const value = pluck(key, item);
                
                return value && value.toString().toLowerCase().trim().includes(queryLowered);
            }));
        }
        isBusy.value = false;
    });

    const resolveDocumentStatusVariant = documentStatus => {
        if (documentStatus === DOCUMENT.STATUES.DRAFT) return 'secondary';
        if (documentStatus === DOCUMENT.STATUES.SENT) return 'warning';
        if (documentStatus === DOCUMENT.STATUES.PENDING) return 'primary';
        if (documentStatus === DOCUMENT.STATUES.COMPLETED) return 'success';
        if (documentStatus === DOCUMENT.STATUES.PHYSICALLY_SIGNED) return 'success';
        if (documentStatus === DOCUMENT.STATUES.DROPBOX_SIGNED) return 'success';
        if (documentStatus === DOCUMENT.STATUES.MARK_AS_SIGNED) return 'success';
        if (documentStatus === DOCUMENT.STATUES.SIGNING) return 'primary';
        if (documentStatus === DOCUMENT.STATUES.CANCELLED) return 'danger';

        return 'primary';
    };

    return {
        sortBy,
        isBusy,
        perPage,
        dataMeta,
        isLoading,
        dataStatus,
        searchQuery,
        currentPage,
        isSortDirDesc,
        totalFileOrFolders,
        perPageOptions,
        refDocumentListTable,

        refetchData,
        tableColumns,
        filterOn,
        resolveDocumentStatusVariant
    };
}
